// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"223a26a2","488":"673ec3e1","977":"98c82ffe"}[chunkId] + ".chunk.js";
};